// extracted by mini-css-extract-plugin
export default {"root":"App_root__nZZtU","header":"App_header__PKNxv","form":"App_form__9MCNp","version":"App_version__68xJj"};